import { constants } from '@bedc/constants';

import { Request } from '../../../../api/user/search/estimators/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const UserEstimatorsType = SearchDataTableType({
	request: Request,
	columnFields: constants.user.search.estimatorColumnFields,
	filterIds: constants.user.search.estimatorFilterFields,
});
